module.exports = __webpack_public_path__ + "static/img/dl_shouji.efbf5a19.png";